<template>
  <div id="header-modal">
    <div class="text-center">
      <div v-if="!isSending && !result">
        <ItemPostImage
          v-if="!isSending && !result"
          @file="setImg"
          class="mx-4 mt-3 mb-0 user-post-image"
          ref="userImage"
        />
        <SButton
          @button="submitPhoto"
          text="Confirm photo"
          color="primary"
          size="md"
          class="mt-3"
          :disabled="btnDisabled"
          data-cy="submitPhotoBtn"
        />
      </div>

      <div v-else-if="result" class="m-5 bold" data-cy="updateHeaderPhotoResult">{{ result }}</div>
      <SButton
        v-if="result"
        @button="resetModal"
        text="Ok"
        color="primary"
        size="md"
        data-cy="updateHeaderPhtoResultBtn"
      />
      <span class="d-block">
        <div
          v-if="isSending && !result"
          class="spinner-border text-primary m-5"
          style="width: 3rem; height: 3rem"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import ItemPostImage from "@/components/molecules/ItemPostImage";
import SButton from "@/components/atoms/SButton";
import UserHelperVue from "../../mixins/UserHelper.vue";
export default {
  name: "ModalUpdateHeaderPhoto",
  mixins: [UserHelperVue],
  components: {
    ItemPostImage,
    SButton,
  },
  data() {
    return {
      img: null,
      error: false,
      isSending: false,
      result: null,
    };
  },
  computed: {
    btnDisabled() {
      return !(this.img);
    },
  },
  methods: {
    async submitPhoto() {
      this.$refs.userImage.clearFile();
      this.isSending = true;
      const data = new FormData();

      data.append("image", this.img);

      const res = await this.uploadHeaderPhoto({
        photo: data,
        id: this.loggedUser.id,
      });
      if (res.result === "Picture updated!") {
        this.isSending = false;
        this.result = "Picture updated!";
        this.$emit("updated");
      } else {
        this.error = true;
      }
    },
    setImg(file) {
      if (file) this.img = file;
    },
    resetModal() {
      this.img = null;
      this.error = false;
      this.isSending = false;
      this.result = null;
      this.$emit("close-modal");
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (
        e.key == "Escape" &&
        $("#header-modal").is(":visible") &&
        this.result
      ) {
        this.resetModal();
      }
    });
    document.addEventListener("click", (event) => {
      if (
        !$(event.target).closest("#header-modal").length &&
        $("#header-modal").is(":visible") &&
        this.result
      ) {
        this.resetModal();
      }
    });
  },
};
</script>


<style lang="scss" scoped>
.borders {
  border-left: none;
  cursor: auto;
}
</style>
